// material-ui
import logoIcon from 'assets/images/icons/logo-icon.png';

const LogoIcon = () => {
  return <img src={logoIcon} alt="ClearSource ATS" width="40" />;
};

export default LogoIcon;
